// extracted by mini-css-extract-plugin
export default {"head":"TitleBanner_head__SOnQa","banner":"TitleBanner_banner__rd3Uy","animate":"TitleBanner_animate__otr5K"};